// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum CustomerSearchType {
  AccountName = 1,
  ShipToLocation = 2,
  EndUser = 3,
  BillToLocation = 4,
}
